import { useState } from 'react'
import { SectionCus } from '../components'

const athletes = [
  {
    name: 'Corinne Carr',
    title: 'Team DUPR Athlete',
    quotetitle: 'Accurately Measure Skill Level',
    quote:
      "I'm so excited that there is finally a framework to accurately measure skill level. Not only is DUPR accurate, but you no longer have to be a tournament player to be rated, making ratings more attainable than ever.",
    image: '/img/Dupr-Athletes/Corinne_Action.png',
    avatar: '/img/Dupr-Athletes/Corinne_Carr_Profile_Image.png',
  },
  {
    name: 'Brandon Nsekpong',
    title: 'Team DUPR Athlete',
    quotetitle: 'A Game Changer for Pickleball',
    quote:
      'Some people play their best games at tournaments and others play theirs in rec play. DUPR captures all that data to make sure your rating reflects what it should: Your game. This is a game changer for the sport of Pickleball.',
    image: '/img/Dupr-Athletes/Brandon_Action.png',
    avatar: '/img/Dupr-Athletes/Brandon_Profile_Image.png',
  },
  {
    name: 'Dekel Bar',
    title: 'Team DUPR Athlete',
    quotetitle: 'A Transparent System',
    quote:
      'I love DUPR because it’s a transparent rating system available to everyone! It’s adaptable so it will keep updating to ensure accuracy. Tournament and rec players can easily get their 3 digit rating and find compatible partners for play!',
    image: '/img/Dupr-Athletes/Dekel_Action.png',
    avatar: '/img/Dupr-Athletes/Dekel_Profile_Image.png',
  },
  {
    name: 'Ben Johns',
    title: 'Team DUPR Athlete',
    quotetitle: 'Accurate and Effective',
    quote:
      'The DUPR rating system does not lose out on any information or data. They incorporate everything into their algorithm, making it the most accurate and effective method for ratings.',
    image: '/img/Dupr-Athletes/Ben_Action.png',
    avatar: '/img/Dupr-Athletes/Ben_Johns_Profile_Image.png',
  },
  {
    name: 'Zane Navratil',
    title: 'Team DUPR Athlete',
    quotetitle: 'Compete with Players of your own Skill Level',
    quote:
      'I enjoy teaching immensely, but it’s always difficult when people sign up for the wrong skill level clinic. They simply don’t know any better. I’m excited to have a way for your every day player to know where they stand so that they can learn and compete with people of their own skill level.',
    image: '/img/Dupr-Athletes/Zane_Action.png',
    avatar: '/img/Dupr-Athletes/Zane_Navratil_Profile_Image.png',
  },
  {
    name: 'Lee Whitwell',
    title: 'Team DUPR Athlete',
    quotetitle: 'Extremely Objective',
    quote:
      'The DUPR rating system provides clubs and organizations with universal, real time ratings for it’s players. It is a rating based solely on the players results therefore making it extremely objective. Leagues, organized play, tournaments, and round robins can be easily run and monitored with DUPR',
    image: '/img/Dupr-Athletes/Lee_Action.png',
    avatar: '/img/Dupr-Athletes/Lee_Whitwell_Profile_Image.png',
  },
]

export const DuprAthletes = () => {
  const [value, setValue] = useState(athletes[0])

  const handleChange = (index: number) => {
    setValue(athletes[index])
  }

  return (
    <div className="bg-white">
      <SectionCus>
        <div className="py-8 px-4 md:py-20 md:px-10  gap-y-3 md:gap-y-6 flex flex-col">
          <p className="text-azul text-xl font-semibold mb-0 text-center">DUPR Athletes</p>
          <p className="text-navyBlue text-5xl leading-tight font-semibold mb-0 text-center">Hear from the Pros</p>
          <div className="flex items-end mt-0 md:mt-10 flex-col md:flex-row">
            <div className="w-full md:w-[55%] lg:w-3/5 pr-0 md:pr-10 lg:pr-20 flex gap-y-6 lg:gap-y-12 flex-col">
              <h1 className="text-3xl text-darkBlue font-semibold">{value.quotetitle}</h1>
              <p className="text-lg text-steel">{value.quote}</p>
              <div className="mb-0 md:mb-6">
                <h3 className="text-lg text-darkNavy font-semibold">{value.name}</h3>
                <span className="text-lg text-steel">{value.title}</span>
              </div>
            </div>
            <div className="w-full md:w-[45%] lg:w-2/5 order-first md:order-last">
              <img src={value.image} alt={value.name} className="w-96 h-96 object-contain" />
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:flex-wrap gap-5 pb-4 mt:0 md:mt-12">
            {athletes.map((item, index) => (
              <div
                key={item.name}
                className={`border rounded cursor-pointer ${
                  JSON.stringify(item) === JSON.stringify(value) ? 'shadow-xl' : ''
                }`}
                onClick={() => handleChange(index)}
              >
                <div key={item.name} className="flex flex-row px-4 py-3 items-center">
                  <div className="rounded-full w-12 h-12">
                    <img src={item.avatar} alt={item.name} />
                  </div>
                  <div className="flex flex-col ml-4">
                    <div className="text-lg text-darkNavy font-semibold capitalize whitespace-nowrap text-left">
                      {item.name}
                    </div>
                    <div className="text-lg text-steel font-normal capitalize whitespace-nowrap text-left">
                      {item.title}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </SectionCus>
    </div>
  )
}
